import Vue from "vue";
import Router from "vue-router";
import store from "@/store.js";
import routerGuard from "@/components/seguridad/routerGuard.js";

Vue.use(Router);

const router = new Router({
  base: "/" + process.env.APP_ID + "/",
  routes: [
    {
      path: "/",
      redirect: { name: "Login" }
    },
    {
      path: "/login",
      name: "Login",
      meta: { auth: false },
      component: () => import("@/views/Login.vue")
    },
    {
      path: "/olvide-contrasena",
      name: "OlvideContrasena",
      meta: { auth: false },
      component: () => import("@/views/OlvideContrasena.vue")
    },
    {
      path: "/configuracion-seguridad",
      name: "ConfiguracionSeguridad",
      meta: { auth: false },
      component: () => import("@/views/ConfiguracionSeguridad.vue")
    }
  ]
});

routerGuard.addRoutes(router);
router.beforeEach((to, from, next) => {
  routerGuard.guard(store, to, from, next);
});

export default router;
